<template>
  <div class="tags">
    <PageHeader :title="title" />

    <VLoader v-if="isLoading" />
    <div v-else>
      <Grid ref="grid" :data-items="tags" :columns="columns">
        <template v-slot:control="{ props }">
            <td class="k-command-cell k-table-td">
              <div class="cell-control">
                <Button
                  :title="getMessageByLang('editText', 'Редактировать')"
                  :theme-color="'primary'"
                  :svg-icon="pencilIcon"
                  @click="edit(props.dataItem.id, 'edit')"
                />
                <Button
                  :title="getMessageByLang('deteleteText', 'Удалить')"
                  :svg-icon="trashIcon"
                  @click="remove(props.dataItem.id, 'delete')"
                >
                </Button>
              </div>
            </td>
          </template>

        <GridToolbar>
          <Button title="Add new" :theme-color="'primary'" @click="createTag">
              {{ getMessageByLang("addText", "Добавить") }}
            </Button>
        </GridToolbar>
      </Grid>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import api from "@/api";
import { getMessageByLang } from "@/utils/translate.js";
import { GridToolbar, Grid } from "@progress/kendo-vue-grid";
import { useRouter } from 'vue-router';

import { Button } from "@progress/kendo-vue-buttons";
import { pencilIcon, trashIcon } from "@progress/kendo-svg-icons";
import VLoader from "@/ui-kit/components/VLoader";
import PageHeader from "@/components/page/PageHeader.vue";

const router = useRouter();
const tags = ref([]);
const isLoading = ref(true);
const title = "Теги";
const columns = [
  {
    field: "name",
    title: getMessageByLang("Название", "Название"),
  },
  {
    field: "description",
    title: getMessageByLang("description", "Описание"),
  },
  {
    field: "control",
    title: getMessageByLang("control", "Управление"),
    cell: "control",
  }
];

const createTag = () => {
    router.push("/admin/tags/null")
}

const edit = (id) => {
  router.push(`/admin/tags/${id}`)
}

const remove = async(id = null) => {
  try {
    await api.tag.delete(id);
    getTags();

  } catch(err) {
    console.error(err);
  }
}

const getTags = async () => {
  try {
    isLoading.value = true;
    const { data } = await api.tags.get();
    tags.value = data.data;
  } catch (err) {
    console.error(err);
    tags.value = [];
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  getTags();
});
</script>